module.exports = __webpack_public_path__ + "media/images/dividend/img-johnbogle-65e88295f960810d84e9f19950b28986.png";